import { IMicrofrontendsAPI } from 'shared/types/applicationContext';

export function callAuthPopup(microfrontendsAPI?: IMicrofrontendsAPI): void {
  void microfrontendsAPI?.header.openAuthModal({
    autoRefresh: true,
    alert: null,
    useDefaultView: false,
    viewData: { headingType: 'informationPermission' },
    source: null,
  });
}
